import { Stack, TextInput } from '@common/ui'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PermissionsMatrix from '../permissions/PermissionsMatrix'
import SectionHeader from './SectionHeader'
import EntityType = com.eidu.entity.type.EntityType
import EntitySelector = com.eidu.entity.selector.EntitySelector

type PermissionPolicyFormProps = {
  entityTypes: readonly EntityType[]
  name: string
  setName: (name: string) => void
  selectedPermissions: readonly PermissionWithId[]
  setSelectedPermissions: (permissions: readonly PermissionWithId[]) => void
}

const PermissionPolicyForm = ({
  entityTypes,
  name,
  setName,
  selectedPermissions,
  setSelectedPermissions,
}: PermissionPolicyFormProps) => (
  <Stack gap="md" style={{ width: '100%', overflowX: 'auto' }}>
    <div
      style={{
        border: '1px solid var(--trellis-color-outline)',
        borderRadius: 'var(--trellis-radius-xs)',
        overflow: 'hidden',
      }}
    >
      <SectionHeader title="Name" />
      <div style={{ padding: 'var(--trellis-spacing-md)' }}>
        <TextInput
          size="sm"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Policy name"
          aria-label="Policy name"
        />
      </div>
    </div>
    <PermissionsMatrix
      entityTypes={entityTypes}
      userSelector={EntitySelector.All}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
    />
  </Stack>
)

export default PermissionPolicyForm
